import { useTranslation } from "react-i18next";
import BarPlot from "../charts/BarPlot";
import DashboardBlockShell from "./DashboardBlockShell";
import BooleanStatsPanel from "./BooleanStatsPanel";
import CategoricalStatsPanel from "./CategoricalStatsPanel";

export default function Bloc2BlockSection({
  id,
  title,
  description,
  loading = false,
  error = null,
  itemsByField,
}) {
  const { t } = useTranslation();
  const boolStats = itemsByField["bloc2.vegetation"]?.stats || null;
  const categoryStats = itemsByField["bloc2.plantType"]?.stats || null;
  const boolChartItems = [
    { category: t("common.yes", "Sí"), count: boolStats?.yes || 0 },
    { category: t("common.no", "No"), count: boolStats?.no || 0 },
  ];
  const categoryChartItems = (categoryStats?.items || []).map((item) => ({
    category: item.category,
    count: item.count,
  }));

  return (
    <DashboardBlockShell
      id={id}
      title={title}
      description={description}
      loading={loading}
      loadingText={t("dashboard.blocks.bloc2.loading", "Carregant estadístiques de bloc2…")}
      error={error}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BooleanStatsPanel
            title={t(
              "dashboard.blocks.bloc2.vegetationPresence",
              "Presència de vegetació"
            )}
            stats={boolStats}
          />
          <CategoricalStatsPanel
            title={t("dashboard.blocks.bloc2.plantTypes", "Tipus de plantes")}
            stats={categoryStats}
          />
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          <BarPlot
            title={t(
              "dashboard.blocks.bloc2.yesNoVegetation",
              "Respostes sí/no sobre vegetació"
            )}
            items={boolChartItems}
          />
          <BarPlot
            title={t(
              "dashboard.blocks.bloc2.plantTypeDistribution",
              "Distribució de tipus de plantes"
            )}
            items={categoryChartItems}
          />
        </div>
      </div>
    </DashboardBlockShell>
  );
}
